import {
  Button,
  ButtonGroup,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Link,
} from "@chakra-ui/react";
import { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { GoX } from "react-icons/go";
import { HiOutlineSearch } from "react-icons/hi";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

export const CellKitsFilterBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [searchText, setSearchText] = useState<string>(
    searchParams.get("searchText") || ""
  );

  const onSubmit = useCallback(
    (newSp: URLSearchParams) => {
      newSp.delete("pageNumber");
      searchParams.sort();
      newSp.sort();

      if (searchParams.toString() !== newSp.toString()) {
        navigate(`?${newSp.toString()}`);
      }
    },
    [searchParams]
  );

  const handleSubmit = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();
      const newSp = new URLSearchParams(location.search);

      if (searchText) {
        newSp.set("searchText", searchText);
      } else {
        newSp.delete("searchText");
      }

      onSubmit(newSp);
    },
    [location.search, searchText, searchParams]
  );

  const clearSearch = () => {
    const newSp = new URLSearchParams(location.search);
    newSp.delete("serialNumber");
    setSearchText("");

    onSubmit(newSp);
  };

  return (
    <Flex flexDirection="row">
      <form onSubmit={handleSubmit}>
        <InputGroup width={503} marginRight="16px">
          <InputLeftElement pointerEvents="none" color="gray.300">
            <HiOutlineSearch />
          </InputLeftElement>
          <Input
            value={searchText}
            onChange={({ currentTarget: { value } }) => setSearchText(value)}
            onBlur={handleSubmit}
            placeholder="Search"
          />
          <InputRightElement>
            <Button variant="ghost" onClick={clearSearch}>
              <GoX />
            </Button>
          </InputRightElement>
        </InputGroup>
      </form>
      <ButtonGroup gap="8px">
        <Link as={RouterLink} to="add">
          <Button colorScheme="brand.blue">Add Cell Kit</Button>
        </Link>
      </ButtonGroup>
    </Flex>
  );
};
